import defaultSettings from '@/settings'

import { getBaseSettingTitle } from '@/api/user'

const title = defaultSettings.title || ''

export default function getPageTitle() {
  let params = {
    type: 2,
    site_type: 3
  }
  getBaseSettingTitle(params).then(res => {
    if (res.code == 1) {
      document.title = res.data.channel_site[0].base_setting_res.title
      sessionStorage.setItem('saveTitle', res.data.channel_site[0].base_setting_res.title)
    }
  })
}
